export const name = "ST_COVEREDBY";
export const summary = `Checks if all points of a \`GEOGRAPHY\` value are on the boundary or interior of another \`GEOGRAPHY\` value.`;
export const reference = `
## ST_COVEREDBY

Checks if all points of a \`GEOGRAPHY\` value are on the boundary or interior of another \`GEOGRAPHY\` value.

\`\`\`
ST_COVEREDBY(geography_1, geography_2)
\`\`\`

### Description

Returns \`FALSE\` if \`geography_1\` or \`geography_2\` is empty. Returns \`TRUE\` if no points of \`geography_1\` lie in the exterior of \`geography_2\`.

Given two \`GEOGRAPHY\`s \`a\` and \`b\`,\`ST_COVEREDBY(a, b)\` returns the same result as \`ST_COVERS\`\`(b, a)\`. Note the opposite order of arguments.


### Return type

\`BOOL\`


source: https://cloud.google.com/bigquery/docs/reference/standard-sql/geography_functions
`;
